<template>
	<v-row>
		<v-dialog v-model="showDialog" :fullscreen="$vuetify.breakpoint.mobile" scrollable persistent no-click-animation max-width="1150px" max-height="90%">
			<v-card>
				<v-card-title style="padding: 5px 0 0 5px;">
					<v-col v-if="!$vuetify.breakpoint.mobile" cols="12">
						<span style="font-size: 20px;">
							{{  $t('wkt.client.expensesheets.confirm-ticket-dialog.title') }}
						</span>
						<!--<v-btn icon style="top: -20px; left: 10px; float: right;">
							<v-icon @click="close()">close</v-icon>
						</v-btn>-->
					</v-col>
					<v-col v-if="$vuetify.breakpoint.mobile" cols="12" class="pa-2 d-flex align-center">
						<!--<v-btn icon @click="close()">
							<v-icon color="#185EA9">arrow_back</v-icon>
						</v-btn>-->
						<span class="text-truncate black--text" style="font-size: 20px;">
							{{ $t('wkt.client.expensesheets.confirm-ticket-dialog.title') }}
						</span>
					</v-col>
				</v-card-title>
				<!--<v-divider></v-divider>-->
				<v-card-text @wheel="onWheel">
					<v-row class="my-4">
						<v-col cols="12" class="text-center">
							<v-icon large color="#185EA9">info</v-icon>
						</v-col>
						<v-col :offset="$vuetify.breakpoint.mobile?'0':'3'" :cols="$vuetify.breakpoint.mobile?'12':'6'" class="d-flex text-center">
							<h3>{{ $t('wkt.client.expensesheets.confirm-ticket-dialog.info') }}</h3>
						</v-col>
					</v-row>     
					<v-form ref="form">
						<v-row>
							<!--<v-col :cols="$vuetify.breakpoint.mobile?'12':'6'">
								<v-autocomplete
								v-model="data.sheetId"
								:items="sheets"
								item-text="name"
								item-value="id"
								:label="$t('wkt.client.expensesheets.edit-item-dialog.expense_sheet')"
								:placeholder="$t('wkt.client.expensesheets.edit-item-dialog.expense_sheet_placeholder')"
								menu-props="bottom, offsetY"
								:rules="[validationRules.required]"
								/>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.mobile?'12':'6'">
								<v-autocomplete
								v-model="data.categoryId"
								:items="categories"
								item-text="name"
								item-value="id"
								:label="$t('wkt.client.expensesheets.edit-item-dialog.category')"
								:placeholder="$t('wkt.client.expensesheets.edit-item-dialog.category_placeholder')"
								menu-props="bottom, offsetY"
								:rules="[validationRules.required]"
								/>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.mobile?'12':'6'">
								<v-autocomplete
								v-model="formatType"
								:items="formatTypes"
								item-text="name"
								item-value="id"
								:label="$t('wkt.client.expensesheets.edit-item-dialog.format_type')"
								:placeholder="$t('wkt.client.expensesheets.edit-item-dialog.format_type_placeholder')"
								menu-props="bottom, offsetY"
								:rules="[validationRules.required]"
								return-object
								/>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.mobile?'12':'6'">
								<v-autocomplete
								v-model="paymentMethod"
								:items="paymentMethods"
								item-text="name"
								item-value="id"
								:label="$t('wkt.client.expensesheets.edit-item-dialog.payment_method')"
								:placeholder="$t('wkt.client.expensesheets.edit-item-dialog.payment_method_placeholder')"
								menu-props="bottom, offsetY"
								:rules="[validationRules.required]"
								return-object
								/>
							</v-col>-->
							<v-col cols="6">
								<v-text-field
								v-model="data.date"
								:label="$t('wkt.client.expensesheets.edit-item-dialog.ticket_date')"
								class="mt-2"    
								readonly 
							/>
							</v-col>
							<v-col cols="6">
								<v-text-field
								v-model="data.time"
								:label="$t('wkt.client.expensesheets.edit-item-dialog.ticket_time')"
								class="mt-2"    
								readonly 
							/>
							</v-col>
							<!--<v-col :cols="$vuetify.breakpoint.mobile?'12':'6'">
								<v-text-field
								v-model="data.expenseDescription"
								:label="$t('wkt.client.expensesheets.edit-item-dialog.expense_description')"
								:placeholder="$t('wkt.client.expensesheets.edit-item-dialog.expense_description_placeholder')"
								autocomplete="none"
								:rules="[validationRules.required]"
								max="255" 
							/>
							</v-col>-->
							<v-col :cols="$vuetify.breakpoint.mobile?'12':'6'">
								<v-text-field
								v-model="data.vendorVatNumber"
								:label="$t('wkt.client.expensesheets.edit-item-dialog.vendor_vat_number')"
								readonly
								max="18" 
							/>
							</v-col>
							<v-col :cols="$vuetify.breakpoint.mobile?'12':'6'">
								<v-text-field
								v-model="data.vendorName"
								:label="$t('wkt.client.expensesheets.edit-item-dialog.vendor_name')"
								readonly
								max="255" 
							/>
							</v-col>
							<v-col cols="6">
								<v-text-field
								v-model="data.taxesPercent"
								:label="$t('wkt.client.expensesheets.edit-item-dialog.taxes_percent')"
								readonly
							/>
							</v-col>
							<v-col cols="6">
								<v-text-field
								v-model="data.taxesAmount"
								:label="$t('wkt.client.expensesheets.edit-item-dialog.taxes_amount')"
								readonly
							/>
							</v-col>
							<v-col cols="6">
								<v-text-field
								v-model="data.grossAmount"
								:label="$t('wkt.client.expensesheets.edit-item-dialog.gross_amount')"
								readonly
							/>
							</v-col>
							<v-col cols="6">
								<v-text-field
								v-model="data.totalAmount"
								:label="$t('wkt.client.expensesheets.edit-item-dialog.total_amount')"
								readonly
							/>
							</v-col>
							<v-col cols="12">
								<v-text-field
								v-model="data.ticketNumber"
								:label="$t('wkt.client.expensesheets.edit-item-dialog.ticket_number')"
								readonly
							/>
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
				<!--<v-divider></v-divider>-->
				<v-card-actions>				
					<v-spacer></v-spacer>
					<v-btn color="#185EA9" text @click="ok()">{{ $t('wkt.client.expensesheets.edit-item-dialog.button-add') }}</v-btn>
					<v-btn text @click="close()">{{ $t('wkt.client.expensesheets.edit-item-dialog.button-reject') }}</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</v-row>	
</template>

<script>
import BaseModule from '../../common/BaseModule.js'

export default {
	name: 'ConfirmTicketDialog',
	mixins: [BaseModule],
	components: {
	},
	data () {
		return {
			showDialog: false,
			data: {},
			msgCb: null
		}
	},
	methods: {
        onWheel(event) {
            event.stopPropagation();
        },
		open(data, msgCb) {
			this.msgCb = msgCb;
			this.showDialog = true;

			this.data = data;
		},
        close() {
            this.showDialog = false;
        },
		ok() {
			this.showDialog = false;
			if (this.msgCb) {
				this.msgCb();
			}
		},
	},
}
</script>